// Transition
export const transition =
  "hover:scale-105 transform transition-transform ease-out duration-300";

// Button Text
export const buttonText =
  "font-proxima text-[14px] font-bold leading-4 text-center";

// Base button class for common styles
export const defaultButton = `w-full sm:w-auto h-[40px] px-[16px] py-[11px] rounded-md text-center font-bold  ${buttonText} inline-flex items-center justify-center ${transition}`;

// Teal button
export const tealButton = `${defaultButton} bg-teal-400 text-[#2B2D42] shadow-button`;

// White outline button
export const whiteOutlineButton = `${defaultButton} border border-white text-white `;

// No outline button
export const purpleNoOutlineButton = `${buttonText} text-cf-primary hover:text-cf-primary inline-flex items-center ${transition}`;

// Section heaader
export const sectionHeader =
  "text-[26px] md:text-[36px] font-extrabold leading-[39px] text-left";

export const subHeader = "text-[24px] font-normal leading-[29.05px] text-left";

export const mediumText =
  " text-[14px] md:text-[16px] font-medium leading-6 text-left ";

export const normalText =
  " text-[14px] md:text-[16px] font-normal leading-6 text-left ";

export const chevronStyling =
  "w-[11px] h-[11px] bg-no-repeat bg-contain transition-all duration-300 inline-block ml-[8px]";

export const defaultChevron = `bg-chevron ${chevronStyling}`;

export const whiteChevron = `bg-chevron-white ${chevronStyling}`;

export const externalLink =
  "font-inter text-[14px] font-bold leading-[24px] text-left underline decoration-solid decoration-from-font text-cf-primary";
